
import { format } from 'date-fns';
import { defineComponent, ref } from 'vue';
import { useCouponStore } from '@/store/useCoupon';
import { storeToRefs } from 'pinia';

export default defineComponent({
  setup() {
    const coupon = useCouponStore();
    const { visible, selectedCoupon } = storeToRefs(coupon);

    const imageAspectRatio = ref(null);

    function handleImageLoad(imageUrl: string): void {
      imageAspectRatio.value = 16 / 9;
      const image = new Image();
      image.src = imageUrl;
      image.onload = () => (imageAspectRatio.value = image.naturalWidth / image.naturalHeight);
    }

    return {
      format,
      handleImageLoad,
      imageAspectRatio,
      resetSelectedCoupon: coupon.resetSelectedCoupon,
      selectedCoupon,
      visible,
    };
  },
});
